import * as z from 'zod';

// ZOD
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';
import { SelectOptionZod } from '@/types/SelectOptionType';
import { TitleZod } from '@/types/TitleType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';
import { MediaZod } from '@/types/MediaType';

const ContactZod = z.object({
  id: z.number(),
  documentId: z.string(),
  title: TitleZod,
  paragraph: ParagraphZod,
  formTitle: TitleZod.nullable(),
  formParagraph: ParagraphZod.nullable(),
  expertises: z.array(SelectOptionZod),
  types: z.array(SelectOptionZod),
  budgets: z.array(SelectOptionZod),
  origins: z.array(SelectOptionZod),
  picture: MediaZod.nullish(),
  blocks: z.array(blocksSchemaZod).nullable(),
  seo: SeoZod,
});

export type ContactType = z.infer<typeof ContactZod>;

export { ContactZod };
